import { render, staticRenderFns } from "./PaperTable.vue?vue&type=template&id=2cd04e46&"
import script from "./PaperTable.vue?vue&type=script&lang=js&"
export * from "./PaperTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports